"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Gift = _interopRequireDefault(require("../../../icons-react/facilities/Gift"));
var HotelCardTitle = function HotelCardTitle(_ref) {
  var name = _ref.name,
    href = _ref.href,
    hasLtExtras = _ref.hasLtExtras,
    _ref$isSmallCard = _ref.isSmallCard,
    isSmallCard = _ref$isSmallCard === void 0 ? false : _ref$isSmallCard,
    dataLayer = _ref.dataLayer,
    isMapCard = _ref.isMapCard;
  return /*#__PURE__*/_react["default"].createElement(StyledLink, {
    as: isMapCard ? 'span' : 'a',
    title: name,
    href: href,
    target: "_blank",
    isSmallCard: isSmallCard,
    rel: "noopener",
    hasExtras: hasLtExtras,
    onClick: function onClick(e) {
      var _dataLayer$hotelClick;
      dataLayer === null || dataLayer === void 0 || (_dataLayer$hotelClick = dataLayer.hotelClicked) === null || _dataLayer$hotelClick === void 0 || _dataLayer$hotelClick.call(dataLayer);
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelName, {
    isSmallCard: isSmallCard,
    itemProp: "name"
  }, name), hasLtExtras && /*#__PURE__*/_react["default"].createElement(StyledIconWrapper, {
    isSmallCard: isSmallCard
  }, /*#__PURE__*/_react["default"].createElement(_Gift["default"], null)));
};
var StyledHotelName = _styledComponents["default"].span.withConfig({
  displayName: "HotelCardTitle__StyledHotelName",
  componentId: "sc-1pgh6yo-0"
})(["overflow:hidden;white-space:nowrap;font-size:22px;line-height:1.2;&:after{content:'';position:absolute;right:0;pointer-events:none;width:140px;height:27px;background-image:linear-gradient( 90deg,rgba(255,255,255,0) 0%,#fff 72% );}", ";"], function (_ref2) {
  var isSmallCard = _ref2.isSmallCard;
  return isSmallCard && "\n    font-size: 18px;\n    white-space: normal;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    &:after { display: none; }\n  ";
});
var StyledIconWrapper = _styledComponents["default"].span.withConfig({
  displayName: "HotelCardTitle__StyledIconWrapper",
  componentId: "sc-1pgh6yo-1"
})(["z-index:1;display:flex;align-items:center;font-weight:normal;*:first-child{width:22px;height:22px;vertical-align:bottom;", "}&:before{content:' +';padding-right:1px;font-size:15px;}"], function (_ref3) {
  var isSmallCard = _ref3.isSmallCard;
  return isSmallCard && "\n      .gift_svg__gift-icon-border { fill: #fff }\n      .gift_svg__gift-icon-bow { stroke: #fff }\n    ";
});
var StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "HotelCardTitle__StyledLink",
  componentId: "sc-1pgh6yo-2"
})(["display:flex;align-items:center;text-decoration:none;font-weight:500;max-width:100%;overflow:hidden;margin-bottom:8px;&:hover{color:", ";text-decoration:none !important;}color:", ";&:hover ", "{.gift_svg__gift-icon-border{fill:", ";}.gift_svg__gift-icon-bow{stroke:", ";}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blue;
}, function (_ref5) {
  var isSmallCard = _ref5.isSmallCard,
    theme = _ref5.theme;
  return isSmallCard ? theme.colors.white : theme.colors.black;
}, StyledIconWrapper, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blue;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blue;
});
HotelCardTitle.displayName = 'HotelCardTitle';
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelCardTitle);